<template>
    <list-widget title="주문상태" minWidth="200" #default="{ attrs }">
        <v-select v-model="query['state']" v-bind="{ ...attrs, items }" dense flat solo hide-details @input="emit" />
    </list-widget>
</template>

<script>
import { NSHOP_ORDER_STATES } from "@/store/nshop";
import ListWidget from "../../dumb/list/list-widget.vue";

const items = [{ value: null, text: "전체" }].concat(...Object.values(NSHOP_ORDER_STATES));

const initQuery = (query = {}) => ({
    ...(query || {}),

    ["state"]: query?.["state"] || null,
});

export default {
    components: {
        ListWidget,
    },
    data: () => ({
        query: initQuery(),
        items,
    }),
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;
            delete query["page"];
            if (!query["state"]) delete query["state"];
            this.$router.push({ query });
        },
    },
    watch: {
        $route() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped></style>
